<template>
  <div class="container">
      <LoadingSpinner :loading="loading"> </LoadingSpinner>

      <div v-if="!loading" class="mt-4 mb-4" style="max-width:560px">
        <h3>Refusjon </h3>
        <div class="mt-4">{{getOrderTypeText()}} - Ordre #{{order.orderId}}</div>

        <div v-if="step == 1">
          <div class="mt-5 mb-0">
            <button type="button" class="bo_btn" @click="selectAllOrRemoveAll"> {{selectAllOrRemoveAllButtonText()}} </button>
          </div>
          <hr class="mb-0"/>
          <div v-for="refundCartItem in refundCartItems" :key="refundCartItem.id" :id="refundCartItem.id" class="refundCartItem clickable-row" @click="updateSelectedCartItems(refundCartItem)">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <input type="checkbox" :name="refundCartItem.id" :value="refundCartItem.id" :checked="selectedCartItemsContains(refundCartItem)" @click.stop="updateSelectedCartItems(refundCartItem)" class="checkbox" />
                <div>
                  <div>
                    {{ refundCartItem.itemName }}
                  </div>
                  <div v-if="refundCartItem.itemSubselection">
                    {{ refundCartItem.itemSubselection.name }}
                  </div>
                  <div v-if="refundCartItem.spicyLevel != ''">
                    {{ refundCartItem.spicyLevel}}
                  </div>
                  <div v-if="refundCartItem.comment != ''">
                    {{ refundCartItem.comment }}
                  </div>
                </div>
              </div>
              <div>
                {{ displayTwoDecimals(getPriceWithVat(refundCartItem)) }}
              </div>
            </div>
          </div>
          <div v-if="order.tipsAmount && order.tipsAmount > 0" class="mt-2 clickable-row" @click="updateRefundedTipsAmount()">
              <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                      <input type="checkbox" :name="'tips_' + order.orderId" :value="'tips_' + order.orderId"
                             :checked="refundedTipsAmount > 0" @click.stop="updateRefundedTipsAmount()"
                              class="checkbox" />
                      <div> Tips </div>
                  </div>
                  <div>
                      {{ displayTwoDecimals(order.tipsAmount) }}
                  </div>
              </div>
          </div>

          <div class="bo_savebtn_container mt-5 mb-5">
            <button type="button" class="bo_btn" @click="step=2" :disabled="disableNextBtn()">Neste</button>
          </div>
        </div>

        <div v-if="step == 2">
          <hr class="mb-0"/>
          <div v-for="selectedCartItem in selectedCartItems" :key="selectedCartItem.id" :id="selectedCartItem.id" class="refundCartItem">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div>
                  <div>
                    -1 x {{selectedCartItem.itemName}}
                  </div>
                  <div v-if="selectedCartItem.itemSubselection">
                    {{ selectedCartItem.itemSubselection.name }}
                  </div>
                  <div v-if="selectedCartItem.spicyLevel != ''">
                    {{ selectedCartItem.spicyLevel}}
                  </div>
                  <div v-if="selectedCartItem.comment != ''">
                    {{ selectedCartItem.comment }}
                  </div>
                </div>
              </div>
              <div>
                -{{ displayTwoDecimals(getPriceWithVat(selectedCartItem)) }}
              </div>
            </div>
          </div>
          <div v-if="refundedTipsAmount > 0" class="mt-2 mb-3">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div> -Tips </div>
              </div>
              <div>
                -{{ displayTwoDecimals(refundedTipsAmount) }}
              </div>
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-between">
            <div>
              <span style="font-weight: bold;">Totalt</span>
            </div>
            <div>
              <span style="font-weight: bold;color: red"> -{{ displayTwoDecimals(getTotalRefundAmount()) }} </span>
            </div>
          </div>

          <div class="bo_savebtn_container mt-5 mb-5">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <button type="button" class="bo_btn" @click="step=1">Tilbake</button>
              </div>
              <div>
                <button type="button" class="bo_btn" @click="refund">Refunder</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ConfirmDialogue ref="confirmDialogue"></ConfirmDialogue>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import OrderService from "@/services/order/OrderService";
import OrderUtil from "@/util/OrderUtil";
import VatUtil from "@/util/VatUtil";
import ConfirmDialogue from "@/components/other/ConfirmDialogue";
import SwedbankPayService from "@/services/payment/SwedbankPayService";
import DinteroService from "@/services/payment/DinteroService";
import VivaService from "@/services/payment/VivaService";
import BonusRefundService from "@/services/payment/BonusRefundService";
import MathUtil from "@/util/MathUtil";

export default {
  components: {LoadingSpinner, ConfirmDialogue},
  data() {
    return {
      loading: true,
      step: 1,

      vat: {},
      orderDocumentId: '',
      order: {
        type: "order",
        merchant: '',
        orderId: '',
        orderType: '',
        orderStatus: '',
        totalAmount: 0,
        tipsAmount: 0,
        description: '',
        pickupOrDeliveryTime: '',
        mobileNumber: '',
        name: '',
        nameOnDoorbell: '',
        street: '',
        houseNumber: '',
        floor: '',
        zipCode: '',
        city: '',
        orderedTime: '',
        modifiedTime: '',
        servedBy: '',
        channel: '',
        payments: [],
        vats: [],
        totalVat: 0,
        cartItems: []
      },
      refundCartItems: [],
      refundedTipsAmount : 0,
      selectedCartItems: []
    };
  },
  mounted() {
    this.orderDocumentId = this.$route.query.orderDocumentId;

    OrderService.getDataForOrderDetailGui(this.orderDocumentId).then(
        (response) => {
          let dataForGui = response.data;
          //console.log('dataForGui: ' + JSON.stringify(dataForGui));
          this.order = dataForGui.order;
          this.vat = dataForGui.vat;
          this.refundCartItems = this.getRefundCartItems();
          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  methods:{
    getOnlinePaymentProvider(){
      let onlinePaymentProvider = OrderUtil.getOnlinePaymentProvider(this.order.payments);
      return onlinePaymentProvider;
    },

    getRefundCartItems(){
      let refundCartItems = [];
      let cartItems = this.order.cartItems;
      console.log('cartItems: ' + JSON.stringify(cartItems));
      for (let i = 0; i < cartItems.length; i++) {
        let cartItem = cartItems[i];
        for(let x = 1; x <= cartItem.count; x++){
          let refundCartItem = {
            originalCartItemId : cartItem.id,
            id: cartItem.id + '_' + x, //make it unique
            itemId: cartItem.itemId,
            itemName: cartItem.itemName || cartItem.itemType,
            itemType: cartItem.itemType,
            price: cartItem.price,
            discountPercent: cartItem.discountPercent ? cartItem.discountPercent : 0,
            count: 1,
            itemSubselection: cartItem.itemSubselection,
            spicyLevel: cartItem.spicyLevel,
            comment: cartItem.comment,
            createdDate: cartItem.createdDate
          };
          refundCartItems.push(refundCartItem);

          //subselection addOns
          if(refundCartItem.itemSubselection){
            let subselectionAddOnCartItems =  refundCartItem.itemSubselection.addOnCartItems;
            if(subselectionAddOnCartItems){
              for(let a = 0; a < subselectionAddOnCartItems.length; a++){
                let addOnCartItem = subselectionAddOnCartItems[a];
                let addOn = addOnCartItem.addOn;
                for(let y = 1; y <= addOnCartItem.count; y++){
                  //Only if it isn't free
                  if(addOnCartItem.price > 0){
                    let addOnRefundCartItem = {
                      originalCartItemId : cartItem.id, //The id of the parent cartItem the addon belongs to.
                      id: cartItem.id + '_' + x + '_' + addOnCartItem.addOnId + '_' + y, //make it unique
                      itemId: addOnCartItem.addOnId,
                      itemName: addOn.name,
                      itemType: 'ADD_ON_OF_ADD_ON_GROUP',
                      price: addOnCartItem.price,
                      discountPercent: cartItem.discountPercent ? cartItem.discountPercent : 0, //The same as cartItem.discountPercent
                      count: 1,
                      createdDate: cartItem.createdDate
                    };
                    refundCartItems.push(addOnRefundCartItem);
                  }
                }
              }
            }
          }

          //item addOns
          if(cartItem.addOnCartItems && cartItem.addOnCartItems.length > 0){
            for (let a = 0; a < cartItem.addOnCartItems.length; a++) {
              let addOnCartItem = cartItem.addOnCartItems[a];
              let addOn = addOnCartItem.addOn;
              for(let y = 1; y <= addOnCartItem.count; y++){
                //Only if it isn't free
                if(addOnCartItem.price > 0){
                  let addOnRefundCartItem = {
                    originalCartItemId : cartItem.id, //The id of the parent cartItem the addon belongs to.
                    id: cartItem.id + '_' + x + '_' + addOnCartItem.addOnId + '_' + y, //make it unique
                    itemId: addOnCartItem.addOnId,
                    itemName: addOn.name,
                    itemType: 'ADD_ON_OF_ADD_ON_GROUP',
                    price: addOnCartItem.price,
                    discountPercent: cartItem.discountPercent ? cartItem.discountPercent : 0, //The same as cartItem.discountPercent
                    count: 1,
                    createdDate: cartItem.createdDate
                  };
                  refundCartItems.push(addOnRefundCartItem);
                }
              }
            }
          }
        }
      }
      return refundCartItems;
    },

    getOrderTypeText(){
      return OrderUtil.getOrderTypeText(this.order.orderType).toUpperCase();
    },
    getPriceWithVat(cartItem){
      let vatRate = VatUtil.getVatRate(this.vat, this.order.orderType, cartItem.itemType);
      let priceWithVat = OrderUtil.getPriceWithVat(vatRate, cartItem.price) * (100 - cartItem.discountPercent) / 100;
      if(cartItem.discountPercent == 0){
        return Math.round(priceWithVat); //make it exact as it is in order description.
      } else {
        return MathUtil.roundTwoDecimals(priceWithVat);
      }
    },
    disableNextBtn(){
      let disabled = this.selectedCartItems.length == 0;
      if(this.order.tipsAmount && this.order.tipsAmount > 0 && disabled){
        if(this.refundedTipsAmount == 0){
          disabled = true;
        } else {
          disabled = false;
        }
      }
      return disabled;
    },
    selectAllOrRemoveAllButtonText(){
      if(this.order.tipsAmount && this.order.tipsAmount > 0){
        if(this.selectedCartItems.length == this.refundCartItems.length && this.refundedTipsAmount > 0){
          return 'Fjern alle valgte';
        }else {
          return 'Velg alle';
        }
      } else {
        if(this.selectedCartItems.length == this.refundCartItems.length){
          return 'Fjern alle valgte';
        }else {
          return 'Velg alle';
        }
      }
    },
    selectAllOrRemoveAll(){
      //console.log('BEFORE: ' + JSON.stringify(this.selectedCartItems));
      if(this.selectedCartItems.length == this.refundCartItems.length){
        //Remove all
        this.selectedCartItems = [];
        this.refundedTipsAmount = 0;
      }else {
        //Add all
        for (let i = 0; i < this.refundCartItems.length; i++) {
          if(!this.selectedCartItemsContains(this.refundCartItems[i])){
            this.selectedCartItems.push(this.refundCartItems[i]);
          }
        }
        this.refundedTipsAmount = this.order.tipsAmount ? this.order.tipsAmount : 0;
      }
      //console.log('AFTER: ' + JSON.stringify(this.selectedCartItems));
    },
    updateRefundedTipsAmount(){
        if(this.refundedTipsAmount > 0){
            this.refundedTipsAmount = 0;
        } else {
            this.refundedTipsAmount = this.order.tipsAmount;
        }
    },
    updateSelectedCartItems(refundCartItem){
      console.log('BEFORE: ' + JSON.stringify(this.selectedCartItems));
        if(this.selectedCartItemsContains(refundCartItem)){
          //Already selected, remove it
          for (let i = 0; i < this.selectedCartItems.length; i++) {
            if (this.selectedCartItems[i].id == refundCartItem.id) {
              this.selectedCartItems.splice(i, 1);
              break;
            }
          }
        }else {
          //Add it
          this.selectedCartItems.push(refundCartItem);
        }
      console.log('AFTER: ' + JSON.stringify(this.selectedCartItems));
    },
    selectedCartItemsContains(cartItem){
      for (let i = 0; i < this.selectedCartItems.length; i++) {
        let selectedCartItem = this.selectedCartItems[i];
        if(selectedCartItem.id == cartItem.id){
          return true;
        }
      }
      return false;
    },
    getTotalRefundAmount(){
      let totalPricesInCart = 0.00;
      for (let i = 0; i < this.selectedCartItems.length; i++) {
          let selectedCartItem = this.selectedCartItems[i];
          let cartItemPrice = this.getPriceWithVat(selectedCartItem);
          console.log(cartItemPrice);
        totalPricesInCart = totalPricesInCart + cartItemPrice;
      }

      totalPricesInCart = totalPricesInCart + this.refundedTipsAmount;
      return totalPricesInCart;
    },
    getTransactionId(){
      let payments = this.order.payments;
      for (let i = 0; i < payments.length; i++) {
        let payment = payments[i];
        if(payment.transactionId){
          return payment.transactionId;
        }
      }
      return null;
    },
    getPaymentOrderId(){
      let payments = this.order.payments;
      for (let i = 0; i < payments.length; i++) {
        let payment = payments[i];
        if(payment.paymentOrderId){
          return payment.paymentOrderId;
        }
      }
      return null;
    },
    /**
     * Calculates how to split the refund between payment provider and bonus points.
     *
     * Strategy: "Payment provider first" — refund via payment provider up to the amount
     * originally charged, then return the rest as bonus points.
     *
     * Examples (order: 500kr total, 200kr bonus, 300kr Dintero):
     *   - Refund 250kr items → 250kr Dintero, 0kr bonus (within provider amount)
     *   - Refund 350kr items → 300kr Dintero, 50kr bonus
     *   - Full refund 500kr  → 300kr Dintero, 200kr bonus
     *   - Tips refund always goes to payment provider
     *
     * For 100% bonus orders (paymentRefundAmount <= 0), caller uses BonusRefundService instead.
     */
    getBonusRefundSplit(){
      let usedPoints = this.order.usedPoints || 0;
      let manualDiscount = this.order.manualDiscount || 0;
      let totalRefundAmount = this.getTotalRefundAmount();
      let refundItemAmount = totalRefundAmount - this.refundedTipsAmount;

      if(usedPoints <= 0){
        return { paymentRefundAmount: totalRefundAmount, bonusRefundAmount: 0 };
      }

      let itemAmountPaidViaProvider = this.order.totalAmount - usedPoints - manualDiscount;
      let paymentRefundForItems = Math.min(refundItemAmount, itemAmountPaidViaProvider);
      let bonusRefundAmount = refundItemAmount - paymentRefundForItems;
      let paymentRefundAmount = paymentRefundForItems + this.refundedTipsAmount;

      return {
        paymentRefundAmount: MathUtil.roundTwoDecimals(paymentRefundAmount),
        bonusRefundAmount: MathUtil.roundTwoDecimals(bonusRefundAmount)
      };
    },
    async refund(){
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Refundere kr ' + this.displayTwoDecimals(this.getTotalRefundAmount()),
        message: 'Vil du refundere kr ' + this.displayTwoDecimals(this.getTotalRefundAmount()) + ' til kunden?',
        okButton: 'Refunder',
        cancelButton: 'Avbryt',
      })
      if(ok) {
        this.loading = true;

        // Create a copy of selectedCartItems with VAT-inclusive prices
        const refundedCartItemsWithVat = this.selectedCartItems.map(cartItem => ({
          ...cartItem,
          price: this.getPriceWithVat(cartItem)
        }));

        let { paymentRefundAmount, bonusRefundAmount } = this.getBonusRefundSplit();

        // If no payment provider amount (100% bonus order), use bonus-only refund
        if(paymentRefundAmount <= 0){
          BonusRefundService.refund(bonusRefundAmount, refundedCartItemsWithVat, this.refundedTipsAmount, this.orderDocumentId).then(
              (response) => {
                if(response.data === 'SUCCEEDED'){
                  this.goToOrderDetailPage();
                }else {
                  this.showRefundFailedMessage();
                  this.loading = false;
                }
              },
              (error) => {
                console.log(error);
              }
          );
          return;
        }

        if(this.getOnlinePaymentProvider() == 'DINTERO'){
          DinteroService.refund(this.getTransactionId(), paymentRefundAmount, refundedCartItemsWithVat, this.refundedTipsAmount, this.orderDocumentId, bonusRefundAmount).then(
              (response) => {
                if(response.data === 'SUCCEEDED'){
                  this.goToOrderDetailPage();
                }else {
                  this.showRefundFailedMessage();
                  this.loading = false;
                }
              },
              (error) => {
                console.log(error);
              }
          );
        } else if(this.getOnlinePaymentProvider() == 'SWEDBANK_PAY'){
          SwedbankPayService.refund(this.getPaymentOrderId(), paymentRefundAmount, refundedCartItemsWithVat, this.refundedTipsAmount, this.orderDocumentId, bonusRefundAmount).then(
              (response) => {
                if(response.data === 'SUCCEEDED'){
                  this.goToOrderDetailPage();
                }else {
                  this.showRefundFailedMessage();
                  this.loading = false;
                }
              },
              (error) => {
                console.log(error);
              }
          );
        } else if(this.getOnlinePaymentProvider() == 'VIVA'){
          VivaService.refund(this.getTransactionId(), paymentRefundAmount, refundedCartItemsWithVat, this.refundedTipsAmount, this.orderDocumentId, bonusRefundAmount).then(
              (response) => {
                if(response.data === 'SUCCEEDED'){
                  this.goToOrderDetailPage();
                }else {
                  this.showRefundFailedMessage(VivaService.refundFailedMessage(response.data, paymentRefundAmount));
                  this.loading = false;
                }
              },
              (error) => {
                console.log(error);
              }
          );
        }
      } else {
        //Cancel, do nothing
        console.log('OnlinePaymentProvider NOT supported');
      }
    },
    goToOrderDetailPage(){
      this.$router.push({ path: 'orderDetail', query: {
          orderDocumentId: this.orderDocumentId
        }
      });
    },
    async showRefundFailedMessage(message){
      const ok = await this.$refs.confirmDialogue.show({
        title: 'Refusjonen mislykket',
        message: message || 'Det skjedde en feil og refusjonen ble ikke fullført.',
        okButton: 'OK',
        cancelButton: 'NOT_SET'
      })
      if(ok) {
        //Do nothing
      }
    },
    displayTwoDecimals(num){
      if(num > 0 || num < 0){
        return MathUtil.displayTwoDecimals(num);
      }else {
        return num;
      }
    }
  }
}
</script>

<style scoped>
  .refundCartItem{
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: var(--bo-muted-2);
    border-bottom: 1px  solid var(--bo-muted-2);
  }

  .checkbox{
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }

  .clickable-row{
    cursor: pointer;
  }
</style>
